import { type ReactNode } from 'react';
import type { ButtonVariant } from '~/components/ui/Button';
import { Dialog, DialogActions, DialogButton, DialogHeader } from '~/components/ui/Dialog';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: VoidFunction;
  handleConfirm: VoidFunction;
  isConfirming?: boolean;
  children: ReactNode;
  confirmButtonNode?: ReactNode;
  titleText?: string;
  confirmButtonVariant?: 'danger' | 'warning';
  confirmButtonType?: ButtonVariant;
  confirmButtonStartIcon?: string;
  maxWidth?: number;
  headerWrapperClassName?: string;
}

export const ConfirmationDialog = ({
  open,
  onClose,
  isConfirming,
  titleText = 'Confirm the action',
  handleConfirm,
  confirmButtonNode = 'Confirm',
  children,
  confirmButtonVariant,
  confirmButtonType,
  confirmButtonStartIcon,
  maxWidth,
  headerWrapperClassName,
}: ConfirmationDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth || 450}
      closeOnBackdropClick={false}
      showCloseButton={false}
    >
      <DialogHeader title={titleText} description={children} wrapperClassName={headerWrapperClassName} />
      <DialogActions>
        <DialogButton variant="secondary" onClick={onClose} disabled={isConfirming}>
          Cancel
        </DialogButton>
        <DialogButton
          disabled={isConfirming}
          onClick={handleConfirm}
          variant={confirmButtonType || 'primary'}
          color={confirmButtonVariant}
          startIcon={confirmButtonStartIcon}
        >
          {isConfirming ? (
            <div className="flex items-center gap-1.5">
              <div className="i-svg-spinners:90-ring-with-bg text-lg" />
              Loading
            </div>
          ) : (
            confirmButtonNode
          )}
        </DialogButton>
      </DialogActions>
    </Dialog>
  );
};
